<app-custom-table
  class="w-full"
  titleSingleResult="Mitgliederbereich"
  titleMultipleResults="Mitgliederbereiche"
  noDataIcon="fa-folders"
  noDataMessage="Dieser Kontakt ist aktuell keinem Mitgliederbereich zugeordnet."
  noSearchResultsIcon="fa-folders"
  noSearchResultsMessage="Es wurden keine Mitgliederbereiche mit diesen Filterkriterien gefunden."
  [columns]="columns"
  [dataSource$]="dataSource$"
  [isLoading]="isLoading"
  [filters]="filters" />
